export type DeliveryAddress = {
  endereco: string;
  latitude: string;
  longitude: string;
  complemento: string;
  bairro?: string;
};

export type DeliveryTerms = { taxa: string; tempo: string };

export const readDeliveryAddress = (): DeliveryAddress => ({
  endereco: window.localStorage.getItem('enderecoEntrega') || '',
  latitude: window.localStorage.getItem('latitudeEntrega') || '',
  longitude: window.localStorage.getItem('longitudeEntrega') || '',
  complemento: window.localStorage.getItem('complementoEntrega') || '',
  ...(window.localStorage.getItem('bairroEntrega') ? { bairro: window.localStorage.getItem('bairroEntrega') || '' } : {})
});

export const saveDeliveryAddress = (address: DeliveryAddress) => {
  window.localStorage.setItem('enderecoEntrega', address.endereco);
  window.localStorage.setItem('latitudeEntrega', address.latitude);
  window.localStorage.setItem('longitudeEntrega', address.longitude);
  window.localStorage.setItem('complementoEntrega', address.complemento || '');
  if (address.bairro) window.localStorage.setItem('bairroEntrega', address.bairro);
  else window.localStorage.removeItem('bairroEntrega');
};

export const saveDeliveryTerms = (taxa: string, tempo: string) => {
  window.localStorage.setItem('taxaEntrega', taxa || '');
  window.localStorage.setItem('tempoEntrega', tempo || '');
};
